import { IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

import { ShareDownloadIcon } from 'src/assets/icons'
import { formatDate } from './format-date'
import { IInvoice, IProfileUserResponse } from 'src/types'

import { useStyles } from './styles'

interface IProps {
  user: IProfileUserResponse
  created: number
  id: string
  amount: number
  invoice: IInvoice
}

export const ListItem = ({ user, created, id, amount, invoice }: IProps) => {
  const classes = useStyles()

  return (
    <li className={classes.invoiceListItem}>
      <div className={classes.invoiceListItemInner}>
        <div className={classes.invoiceTitleWrapper}>
          <h3 className={classes.invoiceListTitle}>{id.slice(-9)}</h3>
          <p className={classes.invoiceListDate}>{formatDate(created * 1000, user?.timezone)}</p>
        </div>
        <p className={classes.invoiceListTitle}>${amount / 100}</p>
      </div>
      <div className={classes.invoiceListBtns}>
        <IconButton
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          href={invoice?.hosted_invoice_url}
          disabled={!invoice?.hosted_invoice_url}
          className={classes.invoiceIcon}
        >
          <VisibilityIcon className={classes.seeIcon} />
        </IconButton>
        <IconButton
          component="a"
          href={invoice?.invoice_pdf}
          download
          disabled={!invoice?.invoice_pdf}
          className={classes.invoiceIcon}
        >
          <ShareDownloadIcon className={classes.seeIcon} />
        </IconButton>
      </div>
    </li>
  )
}
